"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Toggleable form details (only for panel forms)
 * @param showFlag : si true : ajout d'un flag devant le texte
 * @param showLabelKey/hideLabelKey : clés de message
 */
ngModule.directive("tlFormDetails", function ($translate) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      showLabelKey: "@",
      hideLabelKey: "@",
      showLabel: "@",
      hideLabel: "@",
      showFlag: "="
    },
    template: '' + '<div class="tl-form-details" ng-class="{opened : state.opened}">' + '   <a href ng-switch="state.opened"  class="tl-form-detail-link" ng-click="toggle()">' + ' <i ng-if="showFlag" class="mr-s fa fa-eye icon-flag"></i>' + '       <span ng-switch-when="true">{{hideText}}</span>' + '       <span ng-switch-default>{{showText}}</span>' + '   </a>' + '   <div ng-show="state.opened" class="tl-form-details-content" ng-transclude></div>' + '</div>',
    controller: function controller($scope) {
      var ctrl = this;
      var state = $scope.state = {
        opened: false
      };
      ctrl.open = function () {
        state.opened = true;
      };
      ctrl.close = function () {
        state.opened = false;
      };
    },
    link: function link($scope, $el, $attrs) {
      $scope.showText = $scope.showLabel || $translate($scope.showLabelKey || "saisie.formDetails.show");
      $scope.hideText = $scope.hideLabel || $translate($scope.hideLabelKey || "saisie.formDetails.hide");
      $scope.toggle = function () {
        $scope.state.opened = !$scope.state.opened;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/tlFormDetails.js
// module id = 2953
// module chunks = 13